import { useState, useEffect, useRef } from "react";
import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import moment from "moment";
import InfiniteScroll from 'react-infinite-scroll-component';

import { Card, ConfigProvider, Table, Typography, Slider, Button, Select, Skeleton, Radio, Badge } from 'antd';
import { CloudDownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import _ from 'lodash';

import { ErrorResponse } from "utils/types";
import notifier from "utils/notifier";
import { formatDate, formatPhoneNumber, sortArrayByKey, getDisplayCompanyId, isUserEnabledForPBI, addCustomAppInsightsEvent } from "utils/helpers";
import { ClickEvents, LineOfBusiness, UserRole } from 'utils/enums';


import { getAuthEnabledProviderList } from "store/authorization/provider/actions";
import { getMedicareMetricsOverview } from "store/measure/actions";
import { getHistoricalRafScore } from "store/eligibility/rafScore/actions";
import { getProviderHedis, getProviderReport, getDownloadDocument } from "store/eligibility/gap/actions";
import { getMembers, getProviderOverallPerformance, OverallPerformance } from "store/eligibility/measures/actions";
import { getDistinct } from "store/app/providerKeyListWDates/actions";
import { getDistinctVendors } from "store/app/actions";
import { printMembersReport, downloadMemberFile } from "store/app/memberReport/actions";
import { getForAlertsRow1, getAlertCount } from "store/eligibility/members/actions";
import { getMeasureReportPrintFile } from 'store/app/actions';
import {
  getFaxOptOutExists,
  bulkInsertFaxOptOutProviders,
  CheckAttestationVisibility,
  AddAttestationAcknowledgement,
  DownloadAttestation,
  GetAttestationPopupContent,
  getDownloadResources
} from "store/app/actions";
import { get as getProviderKeyListWDates } from "store/app/providerKeyListWDates/actions";
import { showUrgentAnnouncement } from "store/app/announcements/actions";

//eligibility info page related
import { search } from "store/eligibility/actions";
import { getAllDesc, getContractedIPA } from "store/app/ipa/actions";

import SearchMemberForm from 'components/QualityOverview/SearchMemberForm';
import MemoReminderModal from "./MemoReminderModal";
import FloatLabel from "components/Common/FloatLabel";
import SearchMemberResultsTable from "components/Eligibility/SearchMemberResultsTable";

import { GeneralProviderTraining, PNOProviderTraining } from "./Modals";

import QualityOverViewPageProps, { COLUMN_NAME, MeasureMember } from './Proptypes';

import { AddAppInsightEvent } from 'index';

import './index.scss';
import styles from './Modals.module.scss';
import constants from 'constants/index';
import { ALL_TEXT } from 'utils/objects';

const { Title } = Typography;
const { Option } = Select;

const QualityOverViewPage = (props: QualityOverViewPageProps) => {
  const PAGE_SIZE = 20;
  const initialState = {
    agree: false,
    approval: false,
    modified: false,
    denied: false,
    deferred: false,
    cancellation: false,
    dismissal: false,
    priorNotRequired: false,
    otherHealthCare: false,
    notAgree: false,
    selectAll: false
  };

  const history = useHistory();
  const [overallPerformance, setOverallPerformance] = useState<OverallPerformance>({
    OverallPercentile: 0,
    OverallRating: 0,
    TopMeasures: [],
    BottomMeasures: [],
  });
  const [metricScore, setMetricScore] = useState<any>({});
  const [rafScore, setRafScore] = useState<any>([]);
  const [measuresImprovementDataSource, setMeasuresImprovementDataSource] = useState<any>([]);
  const [measureImprovementExpandDataSource, setMeasureImprovementExpandDataSource] = useState<any>([]);
  const [bestMeasures, setBestMeasures] = useState<any>([]);
  const [needsImprovementMeasures, setNeedsImprovementMeasures] = useState<any>([]);
  const [selectedProvider, setSelectedProvider] = useState('');
  const [selectedVendor, setSelectedVendor] = useState('');
  const [lob, setLob] = useState(LineOfBusiness.ALL);
  const [measureYear, setMeasureYear] = useState<number>(moment().year());
  const [gapReportDataSource, setGapReportDataSource] = useState<any>([]);
  const [providerList, setProviderList] = useState<any>([]);
  const [vendorList, setVendorList] = useState<any>([]);
  const [trend, setTrend] = useState('M');
  const [newMembersDataSource, setNewMembersDataSource] = useState<any>([]);
  const [termedMembersDataSource, setTermedMembersDataSource] = useState<any>([]);
  const [ihaMembersDataSource, setIhaMembersDataSource] = useState<any>([]);
  const [newMembersCount, setNewMembersCount] = useState(0);
  const [termedMembersCount, setTermedMembersCount] = useState(0);
  const [ihaMembersCount, setIhaMembersCount] = useState(0);
  const [showTable, setShowTable] = useState(false);
  const [showData, setShowData] = useState(false);
  const [showMeasureTable, setShowMeasureTable] = useState(false);
  const [apiCallCompleted, setApiCallCompleted] = useState(false);
  const [awv, setAWV] = useState(0.0);
  const [searchResult, setSearchResult] = useState<Object[]>([]);
  const [memberOverviewParams, setMemberOverviewParams] = useState(
    {
      vendorId: '',
      pcpKeyId: '',
      companyId: '',
      timeSpan: '',
      pageIndex: 1,
      pageSize: PAGE_SIZE
    }
  );

  const [printParams, setPrintParams] = useState(
    {
      vendorId: '',
      PcpKeyId: '',
      ProviderName: '',
      CompanyId: '',
      TimeSpan: '',
      UserId: sessionStorage.user_id
    }
  );

  const [showAWV, setShowAWV] = useState(false);
  const [showTraining, setShowTraining] = useState(false);
  const [agreementCheckbox, setAgreementCheckbox] = useState('');
  const [showPNOTraining, setShowPNOTraining] = useState(false);
  const [PNOAgreementCheckbox, setPNOAgreementCheckbox] = useState('');

  const [newMembersTableHeight, setNewMembersTableHeight] = useState(0);
  const [termedMembersTableHeight, setTermedMembersTableHeight] = useState(0);
  const [ihaMembersTableHeight, setIhaMembersTableHeight] = useState(0);
  const [membersTableHeight, setMembersTableHeight] = useState(0);
  const [moreNewMembers, setMoreNewMembers] = useState(true);
  const [moreTermedMembers, setMoreTermedMembers] = useState(true);
  const [moreIhaMembers, setMoreIhaMembers] = useState(true);
  const [moreMembers, setMoreMembers] = useState(true);
  const [isVendorDropDownVisible, setIsVendorDropDownVisible] = useState(false);

  let newMembersPageIndex = useRef(1);
  let termedMembersPageIndex = useRef(1);
  let ihaMembersPageIndex = useRef(1);
  let membersPageIndex = useRef(1);

  useEffect(() => {
    getDistinctProviders();
  }, []);

  useEffect(() => {
    if (newMembersDataSource.length === 0) setNewMembersTableHeight(300);
    if (termedMembersDataSource.length === 0) setTermedMembersTableHeight(300);
    if (newMembersDataSource.length === 0) setIhaMembersTableHeight(300);
    //It looks like the ANTD table rows are about 100px each
    if (newMembersDataSource.length > 0) setNewMembersTableHeight((newMembersDataSource.length < 10) ? (newMembersDataSource.length * 55) + 77 : 620);
    if (termedMembersDataSource.length > 0) setTermedMembersTableHeight((termedMembersDataSource.length < 10) ? (termedMembersDataSource.length * 55) + 77 : 620);
    if (ihaMembersDataSource.length > 0) setIhaMembersTableHeight((ihaMembersDataSource.length < 10) ? (ihaMembersDataSource.length * 55) + 77 : 620);

  }, [newMembersDataSource, termedMembersDataSource, ihaMembersDataSource]);

  useEffect(() => {
    if (measureImprovementExpandDataSource.length === 0) setMembersTableHeight(200);
    if (measureImprovementExpandDataSource.length > 0) setMembersTableHeight((measureImprovementExpandDataSource.length < 20) ? measureImprovementExpandDataSource.length * 105 : 1170);

  }, [measureImprovementExpandDataSource]);

  // This happens on page load, changing between radio buttons, and changing provider on the dropdown
  useEffect(() => {
    if (memberOverviewParams.pcpKeyId !== '' && memberOverviewParams.companyId !== '' && memberOverviewParams.timeSpan !== '') {
      updateMemberOverview();
      resetMemberOverview();
    }
  }, [trend, memberOverviewParams])

  // This happens on page load, changing the measure year dropdown
  useEffect(() => {
    // Get the current week number
    const currentWeek = moment().week();
    // Check if it's the first week of the year
    if (currentWeek === 1) {
      // Set the measure year to last year
      setMeasureYear(moment().year() - 1);
    }
  }, [])

  useEffect(() => {
    if (selectedProvider?.length > 0) {
      getDistinctVendor();
      getMeasurePerformance();
      updateMemberImprovement();
      setCollapseState({ expandedRow: "" });
    }
    if (selectedVendor?.length > 0) {
      // fetch data for selected vendor
      getMeasurePerformance();
      updateMemberImprovement();
      setCollapseState({ expandedRow: "" });
    }

  }, [selectedProvider, selectedVendor, lob, measureYear]);

  const [collapseState, setCollapseState] = useState<any>({
    currentPage: 1,
    expandedRow: ""
  });

  const sliderMarkers = {
    0: {
      style: {
        color: '#f50',
      },
      label: <strong>Poor</strong>,
    },
    100: {
      style: {
        color: '#2d8894',
      },
      label: <strong style={{marginRight: 30}}>Excellent</strong>,
    },
  };

  const gapReportColumns = [
    {
      title: 'PHONE NUMBER',
      key: 'RmiCompanyId',
      dataIndex: 'RmiCompanyId',
    },
    {
      title: 'PHONE NUMBER',
      key: 'RmiRevFullName',
      dataIndex: 'RmiRevFullName',
    },
    {
      title: '',
      key: 'Download',
      dataIndex: 'Download',
      render: (_: string, record: any, __: number) => {
        return (<>
          <Button type="link" onClick={() => getDownloadDocument(record.RmiFileNameXLS, record.RmiStoredFilePath)}>Excel File</Button> |
          <Button type="link" onClick={() => getDownloadDocument(record.RmiFileNamePDF, record.RmiStoredFilePath)}>PDF File</Button>
        </>);
      }
    }
  ];

  const measuresImprovementColumns = [
    {
      title: 'Measure Name',
      key: 'RmiMeasureName',
      dataIndex: 'RmiMeasureName',
      sorter: (a: any, b: any) => a.RmiMeasureName.localeCompare(b.RmiMeasureName),
      render: (_: string, record: any, __: number) =>
      {
        if (record.RmiMeasureCode !== 'MHAWV') {
          // Following the exact way how it was done on the legacy code, float doesn't work in the css file
          return (
          <>
            <div className="measure-name" style={{ float: 'left'}}>
              {record.RmiMeasureName}
            </div>
            <div className="progress" style={{backgroundColor: 'rgba(26, 179, 148, 0.5)', width: '50%', float: 'right'}}>
              <div className="progress-bar" style={{textAlign: "right", width: ((record.RmiCompleted/(record.RmiIncomplete + record.RmiCompleted)) * 100 | 0) + '%'}}>
                <div style={{paddingRight: 5, paddingLeft: 5}}>{(record.RmiCompleted/(record.RmiIncomplete + record.RmiCompleted)) * 100 | 0 } %</div>
              </div>
              <div className="progress-bar-markers"></div>
            </div>
          </>
          );
        }
        else {
          return (
            <>
              AWV chase list has moved. Visit our new <u><Link to="/annual-wellness-visit" >Annual Visit Page</Link></u>
            </>
          )
        }
      }
    },
    {
      title: 'Star Rating',
      key: 'starRating',
      dataIndex: 'starRating',
      className: lob === LineOfBusiness.MEDICARE ? "show" : "hide",
      render: (_: string, record: any, __: number) =>
      {
        if (record.RmiMeasureCode !== 'MHAWV') {
          return (
            <div>
              {record.RmiStarRating > 0 ? Array(record.RmiStarRating).fill(<i className="fa fa-star star"></i>) : 'N/A'}
            </div>
          );
        } else {
          return <></>;
        }
      },
    },
    {
      title: '# to Next Star',
      key: 'numberStar',
      dataIndex: 'numberStar',
      className: lob === LineOfBusiness.MEDICARE ? "show" : "hide",
      render: (_: string, record: any, __: number) =>
      {
        if (record.RmiMeasureCode !== 'MHAWV') {
          //Following exactly how it was done on the legacy code
          if (record.RmiCutpoint5 === 0.0 && record.RmiCutpoint4 === 0.0 && record.RmiCutpoint3 === 0.0 && record.RmiCutpoint2 === 0.0 && record.RmiCutpoint1 === 0.0) {
            return (
              <div>
                N/A
              </div>
            );
          }

          if (((record.RmiCompleted / (record.RmiIncomplete + record.RmiCompleted)) < record.RmiCutpoint1) && record.RmiIncomplete <= 1) {
            return (
              <div>
                1
              </div>
            );
          }

          if (((record.RmiCompleted / (record.RmiIncomplete + record.RmiCompleted)) < record.RmiCutpoint1) && record.RmiIncomplete > 1) {
            return (
              <div>
                {calculateNumberToNextStar(record.RmiCompleted, record.RmiIncomplete, record.RmiCutpoint1)}
              </div>
            );
          }

          if (((record.RmiCompleted / (record.RmiIncomplete + record.RmiCompleted)) < record.RmiCutpoint2 && (record.RmiCompleted / (record.RmiIncomplete + record.RmiCompleted)) >= record.RmiCutpoint1)) {
            return (
              <div>
                {calculateNumberToNextStar(record.RmiCompleted, record.RmiIncomplete, record.RmiCutpoint2)}
              </div>
            );
          }

          if (((record.RmiCompleted / (record.RmiIncomplete + record.RmiCompleted)) < record.RmiCutpoint3 && (record.RmiCompleted / (record.RmiIncomplete + record.RmiCompleted)) >= record.RmiCutpoint2)) {
            return (
              <div>
                {calculateNumberToNextStar(record.RmiCompleted, record.RmiIncomplete, record.RmiCutpoint3)}
              </div>
            );
          }

          if ((record.RmiCompleted / (record.RmiIncomplete + record.RmiCompleted)) < record.RmiCutpoint4 && (record.RmiCompleted / (record.RmiIncomplete + record.RmiCompleted)) >= record.RmiCutpoint3) {
            return (
              <div>
                {calculateNumberToNextStar(record.RmiCompleted, record.RmiIncomplete, record.RmiCutpoint4)}
              </div>
            );
          }

          if ((record.RmiCompleted / (record.RmiIncomplete + record.RmiCompleted)) >= record.RmiCutpoint4 && record.RmiCutpoint4 !== 0.0) {
            return (
              <div>
                0
              </div>
            );
          }
        }
        else {
          return <></>;
        }
      }
    },
    {
      title: 'Gap Members',
      key: 'RmiIncomplete',
      dataIndex: 'RmiIncomplete',
      render: (_: string, record: any, __: number) => {
        if (record.RmiMeasureCode !== 'MHAWV') {
          return record.RmiIncomplete;
        }
        else {
          return <></>;
        }
      }
    },
    {
      title: 'Completed Members',
      key: 'RmiCompleted',
      dataIndex: 'RmiCompleted',
      render: (_: string, record: any, __: number) => {
        if (record.RmiMeasureCode !== 'MHAWV') {
          return record.RmiCompleted;
        }
        else {
          return <></>;
        }
      }
    },
    {
      title: 'Total Members',
      key: 'total',
      dataIndex: 'total',
      render: (_: string, record: any, __: number) => {
        if (record.RmiMeasureCode !== 'MHAWV') {
          return (<>
            {record.RmiCompleted + record.RmiIncomplete}
            <Button
              style={{ display: "inline", float: "right" }}
              className="print"
              type="primary"
              icon={<PrinterOutlined />}
              onClick={() => printMeasureReport(record)}
              disabled={!showData}
            >
              Print
            </Button>
          </>);
        }
        else {
          return <></>;
        }
      }
    }
  ];

  const measureImprovementExpandColumns = [
    {
      title: 'Member ID',
      key: 'RmiMemberID',
      dataIndex: 'RmiMemberID',
      render: (_: string, record: any, __: number) => <a onClick={() => switchToEligibilityDetailPage(record, ClickEvents.MEMBER_MEASURE_IMPROVEMENT)}>{record.RmiMemberID}</a>
    },
    {
      title: 'Member Name',
      key: 'RmiMemberName',
      dataIndex: 'RmiMemberName'
    },
    {
      title: 'Date of Birth',
      key: 'RmiBirth',
      dataIndex: 'RmiBirth',
      render: (_: string, record: any, __: number) => formatDate(record.RmiBirth, 'MM/DD/YYYY')
    },
    {
      title: 'Phone Number',
      key: 'RmiPhone',
      dataIndex: 'RmiPhone',
      render: (_: string, record: any, __: number) => formatPhoneNumber(record.RmiPhone)
    }
  ];

  const newMembersColumns = [
    {
      title: <>New members <Badge count={newMembersCount} overflowCount={99999} offset={[10, -3]}></Badge></>,
      key: 'RmiRevFullName',
      dataIndex: 'RmiRevFullName',
      render: (_: string, record: any, __: number) =>
        <a onClick={() => switchToEligibilityDetailPage(record, ClickEvents.MEMBER_OVERVIEW_NEW)}>{record.RmiRevFullName}</a>
    },
    {
      title: 'Start Date',
      key: 'RmiPcPFromDt',
      dataIndex: 'RmiPcPFromDt',
      render: (_: string, record: any, __: number) => formatDate(record.RmiPcPFromDt, 'MM/DD/YYYY')
    },
  ];

  const termedMembersColumns = [
    {
      title: <>Termed Members <Badge count={termedMembersCount} overflowCount={99999} offset={[10, -3]}></Badge></>,
      key: 'RmiRevFullName',
      dataIndex: 'RmiRevFullName',
      render: (_: string, record: any, __: number) =>
        <a onClick={() => switchToEligibilityDetailPage(record, ClickEvents.MEMBER_OVERVIEW_TERMED)}>{record.RmiRevFullName}</a>
    },
    {
      title: 'Termed Date',
      key: 'RmiPcpThruDt',
      dataIndex: 'RmiPcpThruDt',
      render: (_: string, record: any, __: number) => formatDate(record.RmiPcpThruDt, 'MM/DD/YYYY')
    },
  ];

  const ihaMembersColumns = [
    {
      title: <>IHA Members <Badge count={ihaMembersCount} overflowCount={99999} offset={[10, -3]}></Badge></>,
      key: 'RmiRevFullName',
      dataIndex: 'RmiRevFullName',
      render: (_: string, record: any, __: number) =>
        <a onClick={() => switchToEligibilityDetailPage(record, ClickEvents.MEMBER_OVERVIEW_IHA)}>{record.RmiRevFullName}</a>
    },
    {
      title: 'Enrollment Date',
      key: 'RmiPcPFromDt',
      dataIndex: 'RmiPcPFromDt',
      render: (_: string, record: any, __: number) => formatDate(record.RmiPcPFromDt, 'MM/DD/YYYY')
    },
  ];

  const resetMemberOverview = () => {
    setNewMembersDataSource([]);
    setTermedMembersDataSource([]);
    setIhaMembersDataSource([]);
    newMembersPageIndex.current = 1;
    termedMembersPageIndex.current = 1;
    ihaMembersPageIndex.current = 1;
    setMoreNewMembers(true);
    setMoreTermedMembers(true);
    setMoreIhaMembers(true);
  }

  const onTrendChange = (e: any) => {
    setTrend(e.target.value);
    setMemberOverviewParams((prev: any) => ({ ...prev, timeSpan: e.target.value }) );
    setPrintParams((prev: any) => ({ ...prev, TimeSpan: e.target.value }));
  };

  //used for dropdown list on gap member report page
  const getDistinctProviders = () => {
    return props.getDistinct(sessionStorage.getItem('user_id')!)
      .then((providers: any[]) => {
        // User Story 27664 Part 1: Expiring Providers Urgent Popup
        // User Story 28041 Part 2: Remove urgent popup (already past due date)
        // if (providers.some(provider => EXPIRING_PROVIDER_ID_LIST.includes(provider.RmiProvId))) {
        //   props.showUrgentAnnouncement();
        // }
        const formatProviders = formatName(providers);
        const pcps = formatProviders.filter((prov: any) => {
          return ((prov.RmiClass === "D" || prov.RmiClass === "P" || prov.RmiClass === "3C" || prov.RmiClass === "C") && (prov.RmiClaimAccessDays === null || parseInt(prov.RmiClaimAccessDays) > 0));
        });

        if (pcps.length > 0) {
          updateSelectedProvider(JSON.stringify(pcps[0])); //updates the view members section
          setSelectedProvider(JSON.stringify(pcps[0]));
          const providerList = sortArrayByKey(pcps, 'Provider');
          setProviderList(providerList); //used for the provider dropdown list
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  const getDistinctVendor = () => {
    if (selectedProvider !== null && selectedProvider !== '' ) {
      const providerObject = JSON.parse(selectedProvider);
      return props.getDistinctVendors(providerObject.rmiProvKeyId, providerObject.rmiCompanyId)
        .then((vendors: any[]) => {
          if (vendors.length > 0) {
            setIsVendorDropDownVisible(true);
            // updateSelectedVendor(JSON.stringify(vendors[0]));
            // setSelectedVendor(JSON.stringify(vendors[0]));
            const vendorList = sortArrayByKey(vendors, 'Vendor');
            setVendorList(vendorList);
          } else {
            setIsVendorDropDownVisible(false);
          }
        })
        .catch((err: ErrorResponse) => {
          notifier.error(err.response?.data.Message || 'Something went wrong, please contact a system administrator.');
        });
    }
  }

  const printMeasureReport = (record: any) => {
    const params = {
        "PcpKeyId": printParams.PcpKeyId,
        "ProviderName": printParams.ProviderName,
        "CompanyId": printParams.CompanyId,
        "TimeSpan": printParams.TimeSpan,
        "UserId": sessionStorage.user_id,
        "MeasureCode": record.RmiMeasureCode,
        "LOB": lob,
        "MeasureName": record.RmiMeasureName,
        "MeasureYear": measureYear,
        "VendorId": printParams.vendorId
    }

    AddAppInsightEvent(
      {
        "name": ClickEvents.PRINT_MEASURE_REPORT,
        "properties": {
          "userName": sessionStorage.user_id,
          "CompanyId": printParams.CompanyId,
          "MeasureCode": record.RmiMeasureCode,
          "MeasureName": record.RmiMeasureName,
          "VendorId": printParams.vendorId,
          lob,
          measureYear
        },
      },
      sessionStorage.user_id
    );

    props.getMeasureReportPrintFile(params)
      .then((response: any) => {
        let blob = new Blob([response], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, "_blank", "");
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  const printMembersReport = () => {
    props.printMembersReport(printParams)
      .then((response: any) => {
        let blob = new Blob([response], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, "_blank", "");
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  const printSummary = () => {
    $(".print, .ant-table-row-expand-icon, th:nth-child(1), td:nth-child(1)").removeClass("include-print").addClass("exclude-print");
    $(".measures-form-improvement").removeClass('exclude-print').addClass("include-print");
    window.print();
  }

  const printGapReportInXlsx = () => {
    printGapReport("XLSX");
  }

  const printGapReportInPdf = () => {
    printGapReport("PDF");
  }

  const printGapReport = (type: string) => {

    const providerObject = JSON.parse(selectedProvider);
    const vendorObject = (selectedVendor !== null && selectedVendor !== '' ) ? JSON.parse(selectedVendor) : '';
    props.getProviderReport(providerObject.rmiProvKeyId, providerObject.rmiCompanyId, sessionStorage.user_id, 'HEDIS', measureYear, vendorObject.RmiVendorId)
    .then((response: any[]) => {

      if (response != null && response[0] != null) {
        let fileName = type === "XLSX" ? response[0].RmiFileNameXLS : response[0].RmiFileNamePDF;

        const model = {
          "FileName": fileName,
          "FilePath": "",
          "CompanyId": providerObject.rmiCompanyId,
          "ProviderId": providerObject.RmiProvId,
          "ProviderName": providerObject.rmiRevFullName,
          "MeasureYear": measureYear
        }
        addCustomAppInsightsEvent(ClickEvents.DOWNLOAD_HEDIS_GAP_REPORT, model);

        return props.getDownloadDocument(model)
          .then((res: ArrayBuffer) => {
            let fileType;
            if (type === "XLSX") {
              fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            } else {
              fileType = "application/pdf";
            }
            let blob = new Blob([res], {type: fileType});
            const fileURL = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.download = fileName.replace(/(\.[^\.]+)$/, `_${measureYear}$1`);
            anchor.href = fileURL;
            anchor.click();

            notifier.success("File exported successfully.");
          })
          .catch((err: ErrorResponse) =>
            notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.')
          );
      }
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
    });

  }

  const downloadMemberFile = () => {
    props.downloadMemberFile(printParams)
      .then((response: any) => {
        const file = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileURL = URL.createObjectURL(file);
        const anchor = document.createElement("a");
        anchor.download = 'MemberReport.xlsx';
        anchor.href = fileURL;
        anchor.click();
        notifier.success('Success! File has downloaded.');
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  const updateMemberOverview = () => {
    getAlertCount();
    getForAlertsRowOne(PAGE_SIZE, COLUMN_NAME.ALL);
  }

  const updateMemberImprovement = () => {
    setOverallPerformance((prev: any) => ({ ...prev }));
    setShowData(true);
  }

  const getMeasurePerformance = () => {
    getProviderOverallPerformance();
    getHistoricalRafScore();
    getMedicareMetricsOverview();
    getProviderReport();
    getProviderHedis();
  }

  //@TODO until the data sources are separates in their own API, for now we need to keep track of the pagination
  const getForAlertsRowOne = (pageSize: number, column: string, pageIndex: number = 1) => {
    return props.getForAlertsRow1(
      memberOverviewParams.pcpKeyId,
      memberOverviewParams.companyId,
      memberOverviewParams.timeSpan,
      pageIndex,
      pageSize,
      memberOverviewParams.vendorId,
    )
    .then((response: any) => {
      if (column === COLUMN_NAME.NEW_MEMBERS) {
        setNewMembersDataSource((prev: any) => [...prev, ...response.RmiNewMembers]);
        setMoreNewMembers((response.RmiNewMembers.length < PAGE_SIZE) ? false : true);
        newMembersPageIndex.current++;
      }

      if (column === COLUMN_NAME.TERMED_MEMBERS) {
        setTermedMembersDataSource((prev: any) => [...prev, ...response.RmiTermedMembers]);
        setMoreTermedMembers((response.RmiTermedMembers.length < PAGE_SIZE) ? false : true);
        termedMembersPageIndex.current++;
      }

      if (column === COLUMN_NAME.IHA_MEMBERS) {
        setIhaMembersDataSource((prev: any) => [...prev, ...response.RmiIhaMembers]);
        setMoreIhaMembers((response.RmiIhaMembers.length < PAGE_SIZE) ? false : true);
        ihaMembersPageIndex.current++;
      }

      if (column === COLUMN_NAME.ALL && response.RmiIhaMembers && response.RmiTermedMembers && response.RmiNewMembers) {
        setNewMembersDataSource((prev: any) => [...prev, ...response.RmiNewMembers]);
        setTermedMembersDataSource((prev: any) => [...prev, ...response.RmiTermedMembers]);
        setIhaMembersDataSource((prev: any) => [...prev, ...response.RmiIhaMembers]);

        setMoreNewMembers((response.RmiNewMembers.length < PAGE_SIZE) ? false : true);
        setMoreTermedMembers((response.RmiTermedMembers.length < PAGE_SIZE) ? false : true);
        setMoreIhaMembers((response.RmiIhaMembers.length < PAGE_SIZE) ? false : true);

        newMembersPageIndex.current++;
        termedMembersPageIndex.current++;
        ihaMembersPageIndex.current++;
      }
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err.response?.data.Message || 'Something went wrong, please contact a system administrator.');
    });
}

  const getAlertCount = () => {
    props.getAlertCount(
      memberOverviewParams.pcpKeyId,
      memberOverviewParams.companyId,
      memberOverviewParams.timeSpan,
      memberOverviewParams.vendorId
    )
    .then((response: any) => {
      setNewMembersCount(response.RmiNewMembers);
      setTermedMembersCount(response.RmiTermedMembers);
      setIhaMembersCount(response.RmiIhaMembers);
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err.response?.data.Message || 'Something went wrong, please contact a system administrator.');
    })
  }

  const updateSelectedProvider = (provider: string) => {
    const providerObject = JSON.parse(provider);

    setTrend('M'); //reset the radio button back to 3 months
    setPrintParams({
      vendorId: '',
      PcpKeyId: providerObject.rmiProvKeyId,
      ProviderName: providerObject.RmiFullName,
      CompanyId: providerObject.rmiCompanyId,
      TimeSpan: 'M',
      UserId: sessionStorage.user_id
    });

    setMemberOverviewParams({
      vendorId: '',
      pcpKeyId: providerObject.rmiProvKeyId,
      companyId: providerObject.rmiCompanyId,
      timeSpan: 'M',
      pageIndex: 1,
      pageSize: PAGE_SIZE
    });

    setSelectedProvider(provider);
  }

  const updateSelectedVendor = (vendor: string) => {
    const vendorObj = JSON.parse(vendor);
    const providerObject = JSON.parse(selectedProvider);
    setTrend('M'); //reset the radio button back to 3 months
    setPrintParams({
      vendorId: vendorObj.RmiVendorId,
      PcpKeyId: vendorObj.RmiProvKeyId,
      ProviderName: providerObject.RmiFullName,
      CompanyId: vendorObj.RmiCompanyId,
      TimeSpan: 'M',
      UserId: sessionStorage.user_id
    });

    setMemberOverviewParams({
      vendorId: vendorObj.RmiVendorId,
      pcpKeyId: vendorObj.RmiProvKeyId,
      companyId: vendorObj.RmiCompanyId,
      timeSpan: 'M',
      pageIndex: 1,
      pageSize: PAGE_SIZE
    });

    setSelectedVendor(vendor);
  }

  const calculateNumberToNextStar = (completed: number, inCompleted: number, cutPoint: number) => {
    return (cutPoint * (inCompleted + completed) - completed) < 1 ? 1 : Math.ceil(cutPoint * (inCompleted + completed) - completed);
  }

  const handleRowExpand = (record: any) => {
    membersPageIndex.current = 1;
    setMeasureImprovementExpandDataSource([]);
    //if it's a different row key, then call the API and expand the accordion
    if (collapseState.expandedRow !== record.key) {
      getMembers(record);
      //This currently only allows to expand one at a time and update the state to manage 1 row (historical condition) at a time
      setCollapseState({ expandedRow: record.key });
    }
    else {
      //close collapse state and not call the API
      setCollapseState({ expandedRow: "" });
    }
  }

  const newTableDataHandler = (searchResult: any) => {
    setShowTable(searchResult.length > 0 ? true : false);
    setSearchResult(searchResult);
  }

  const switchToEligibilityDetailPage = (memberInfo: any, type: string) => {
    //According to legacy code
    const provider = (sessionStorage.user_role === UserRole.CASE || sessionStorage.user_role === UserRole.IPA) ? "OTHER" : "PCP";
    const providerObject = JSON.parse(selectedProvider);
    let formData = {
      "DateOfBirth": memberInfo.RmiBirth,
      "MemberId": memberInfo.RmiMemberID || memberInfo.RmiMembId, //GetMeasureMembers() api uses RmiMemberID and GetMembersForAlertsRow1() api uses RmiMembId
      "Provider": provider,
      "UserId": sessionStorage.user_id,
      "CompanyId": sessionStorage.getItem("ipaGroup")
    }
    addCustomAppInsightsEvent(type, formData);

    return props.search(formData)
      .then((response: any) => {
        if (response.length > 0) {
          const memberSelected = response.find((member: any) => member.RmiCompanyId === providerObject.rmiCompanyId && member.RmiProvKeyId === providerObject.rmiProvKeyId);
          history.push({
            pathname: '/eligibility/member-detail',
            state: {
              eligibilityMemberInfo: memberSelected
            }
          });
        } else {
          notifier.error('No access. Please use eligibility to search for this member.');
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  const getMedicareMetricsOverview = () => {
    const providerObject = JSON.parse(selectedProvider);
    const vendorObject = (selectedVendor !== null && selectedVendor !== '' ) ? JSON.parse(selectedVendor) : '';
    var vendorId = (vendorObject !== null && vendorObject !== '' ) ? vendorObject.RmiVendorId : '';

    return props.getMedicareMetricsOverview(sessionStorage.user_id, providerObject.rmiProvKeyId, providerObject.rmiCompanyId, measureYear, vendorId)
      .then((response: any) => {
        setMetricScore(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  const getHistoricalRafScore = () => {
    const providerObject = JSON.parse(selectedProvider);
    const vendorObject = (selectedVendor !== null && selectedVendor !== '' ) ? JSON.parse(selectedVendor) : '';
    var vendorId = (vendorObject !== null && vendorObject !== '' ) ? vendorObject.RmiVendorId : '';

    return props.getHistoricalRafScore(providerObject.RmiProvId, providerObject.rmiCompanyId, sessionStorage.user_id, measureYear, vendorId)
      .then((response: any) => {
        setRafScore(response ? response : []);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  //Gap Report at the bottom
  const getProviderReport = () => {

    const providerObject = JSON.parse(selectedProvider);
    const vendorObject = (selectedVendor !== null && selectedVendor !== '' ) ? JSON.parse(selectedVendor) : '';

    return props.getProviderReport(providerObject.rmiProvKeyId, providerObject.rmiCompanyId, sessionStorage.user_id, 'HCC', measureYear, vendorObject.RmiVendorId)
      .then((response: any) => {
        //response returns an object. Antd <Table> needs it in array
        setGapReportDataSource(response !== null ? [response] : []);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  //Measures for Improvement table API
  const getProviderHedis = () => {
    const providerObject = JSON.parse(selectedProvider);
    const vendorObject = (selectedVendor !== null && selectedVendor !== '' ) ? JSON.parse(selectedVendor) : '';

    return props.getProviderHedis(providerObject.rmiProvKeyId, providerObject.rmiCompanyId, lob, measureYear, vendorObject.RmiVendorId)
      .then((response: any) => {
        const measuresImprovementResults: Object[] = [];
        let showAWV = false;
        for (const key in response) {

          if (lob !== LineOfBusiness.MEDICARE && (response[key].RmiCompleted + response[key].RmiIncomplete) !== 0) {
            const rating = (response[key].RmiCompleted / (response[key].RmiCompleted + response[key].RmiIncomplete));
            measuresImprovementResults.push({
              ...response[key],
              rating: rating,
              key: key // need this key for expanding the rows later
            });
          }

          //hide no star ratings ONLY for Medicare measures
          if (lob === LineOfBusiness.MEDICARE &&
            (response[key].RmiCompleted + response[key].RmiIncomplete) !== 0 &&
            (
              response[key].RmiCutpoint1 !== 0 &&
              response[key].RmiCutpoint2 !== 0 &&
              response[key].RmiCutpoint3 !== 0 &&
              response[key].RmiCutpoint4 !== 0 &&
              response[key].RmiCutpoint5 !== 0
            )) {
            const rating = (response[key].RmiCompleted / (response[key].RmiCompleted + response[key].RmiIncomplete));
            measuresImprovementResults.push({
              ...response[key],
              rating: rating,
              key: key // need this key for expanding the rows later
            });
          }

          if (response[key].RmiMeasureCode === 'MHAWV') {
            setAWV((response[key].RmiCompleted / (response[key].RmiCompleted + response[key].RmiIncomplete)) * 100);
            showAWV = true;
          }
        }

        const sortedMeasuresImprovement = _.orderBy(measuresImprovementResults, 'RmiMeasureName', 'asc')
        // Annual Wellness visit to top of the list
        sortedMeasuresImprovement.forEach((item: any, index: number) => {
          if(item.RmiMeasureCode === 'MHAWV'){
            sortedMeasuresImprovement.splice(index, 1);
            sortedMeasuresImprovement.unshift(item);
          }
        });

        setApiCallCompleted(true);
        setShowAWV(showAWV);
        setShowMeasureTable((sortedMeasuresImprovement.length === 0 && lob === LineOfBusiness.ALL) ? false : true);

        setMeasuresImprovementDataSource(sortedMeasuresImprovement);
      })
      .catch((err: ErrorResponse) => {
        //@TODO -The error message from the back-end is super long
        setApiCallCompleted(true);
        notifier.error('Something went wrong, please contact a system administrator.');
      });
  }

  //Measures for Improvement table (expanded accordion) API
  const getMembers = (record: any, pageIndex: number = 1) => {
    const providerObject = JSON.parse(selectedProvider);
    const vendorObject = (selectedVendor !== null && selectedVendor !== '' ) ? JSON.parse(selectedVendor) : '';
    const pageSize = 50;

    AddAppInsightEvent(
      {
        "name": ClickEvents.EXPAND_MEASURE,
        "properties": {
          "userName": sessionStorage.user_id,
          "CompanyId": providerObject.rmiCompanyId,
          "MeasureCode": record.RmiMeasureCode,
          "MeasureName": record.RmiMeasureName,
          "VendorId": vendorObject.RmiVendorId,
          lob,
          measureYear
        },
      },
      sessionStorage.user_id
    );

    return props.getMembers(
      record.RmiMeasureCode,
      providerObject.rmiProvKeyId,
      providerObject.rmiCompanyId,
      lob,
      pageIndex,
      pageSize,
      measureYear,
      vendorObject.RmiVendorId
    ).then((response: MeasureMember[]) => {
        if (response === null) { // Database not available
          notifier.error('Something went wrong, please contact a system administrator.');
          return;
        }
        setMeasureImprovementExpandDataSource((prev: MeasureMember[]) => [...prev, ...response]);
        setMoreMembers((response.length < 50) ? false : true);
        membersPageIndex.current++;
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  //export excel API
  const getDownloadDocument = (fileName: string, filePath: string) => {
    const model = {
      "FileName": fileName,
      "FilePath": filePath
    }

    return props.getDownloadDocument(model)
      .then(() => {
        notifier.success("File exported successfully.");
      })
      .catch((err: ErrorResponse) =>
        notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.')
      );
  }

  const getProviderOverallPerformance = () => {
    const providerObject = JSON.parse(selectedProvider);
    const vendorObject = (selectedVendor !== null && selectedVendor !== '' ) ? JSON.parse(selectedVendor) : '';
    const formData = {
      "providerKeyId": providerObject.rmiProvKeyId,
      "companyId": providerObject.rmiCompanyId,
      "measureYear": measureYear,
      "userId": sessionStorage.user_id,
      "vendorId": vendorObject.RmiVendorId
    }

    return props.getProviderOverallPerformance(formData)
      .then((response: OverallPerformance) => {
        setBestMeasures(_.orderBy(response.TopMeasures, 'StarRating', 'desc'));
        setNeedsImprovementMeasures(_.orderBy(response.BottomMeasures, 'StarRating', 'asc'));
        setOverallPerformance(response);
      })
      .catch((err: ErrorResponse) =>
        //@TODO -The error message from the back-end is super long
        notifier.error('Something went wrong, please contact a system administrator.')
      );
  }

  //exact logic taken from the legacy code to add in these special distinct providers under gap member report page
  const formatName = (providers: any) => {
    providers.forEach((data: any) => {
      if (data.rmiRevFullName !== null) {
        const splitData = data.rmiRevFullName.split(",");
        data.rmiRevFullName = splitData.join(", ");
      }
      data.Provider = getDisplayCompanyId(data.rmiCompanyId) + " - (" + data.RmiClass + ") " + data.rmiRevFullName;
    });

    return providers;
  }

  // Reusable MetricCard component
  const MetricCard: React.FC<{ title: string; score: number | string }> = ({ title, score }) => (
    <div className="col-lg-8">
      <Card className="card-box mb-3">
        <div className="metric-name">{title}</div>
        <div className="metric-score">{score}</div>
      </Card>
    </div>
  );

  // This function redirects the user to the PowerBI dashboard when the button is clicked.
  const handleOpenClick = () => {
    history.push('/powerbi');
  };

  return (
    <>
      <div className="quality-overview-page">
        <div className="header-title">
          <Title level={4} className="ml-3">Quality Overview</Title>
        </div>

        <Card className="mb-4 search-card">
          <Title level={5}>Member Search</Title>
          <div className="search-section">
            <SearchMemberForm
              search={props.search}
              getAllDesc={props.getAllDesc}
              getContractedIPA={props.getContractedIPA}
              newTableDataHandler={newTableDataHandler}
              isSearchingMembers={props.isSearchingMembers}
              redirect={false}
            />
          </div>

          { showTable && (
            <div className="content">
              <SearchMemberResultsTable
                dataSource={searchResult}
                isSearchingMembers={props.isSearchingMembers}
              />
            </div>
          )}

        </Card>

        { props.isFetchingHEDIS && props.isFetchingMedicare ? (
          <>
            <Skeleton
              active
              paragraph={{ rows: 3 }}
            />
            <br />
            <Skeleton
              avatar
              active
              paragraph={{ rows: 3 }}
            />
            <br />
            <Skeleton
              active
              paragraph={{ rows: 3 }}
            />
          </>
        ) : (
          <>
            <div className="mb-4 provider-vendor" style={{width: '100%'}}>

              <div className="row">
                <div className="col-lg-12 col-md-4"  style={{ textAlign: "left" }}>
                  <label>Provider</label>
                </div>
                {isVendorDropDownVisible ?
                (
                  <>
                    <div className="col-lg-12 col-md-4"  style={{ textAlign: "left" }}>
                      <label>Vendor</label>
                    </div>
                  </>
                ) : null
                }

              </div>

              <div className="row">
                <div className="col-lg-12 col-md-4">
                  <Select
                    className="providerList mt-2"
                    style={{ width: "500px", bottom: "5px"}}
                    showSearch
                    value={selectedProvider}
                    onSelect={value => updateSelectedProvider(value)}
                    loading={props.isFetchingDistinct}
                    >
                    {providerList.map((option: any, index: number) => {
                      return <Option key={index} value={JSON.stringify(option)}>{`${option.Provider} (${option.RmiCity ? option.RmiCity : 'N/A'}${option.RmiStreet ? ` ${option.RmiCity}`: ''})`}</Option>;
                    })}
                  </Select>
                </div>
                {isVendorDropDownVisible ?
                  (
                    <>
                      <div className="col-lg-12 col-md-4">
                        <Select
                          className="vendorList mt-2"
                          style={{ width: "500px", bottom: "5px"}}
                          showSearch
                          value={selectedVendor}
                          onSelect={value => updateSelectedVendor(value)}
                          placeholder="Select Vendor"
                          loading={props.isFetchingDistinct}
                          >
                          {vendorList.map((option: any, index: number) => {
                            return <Option key={index} value={JSON.stringify(option)}>{`${option.RmiVendorName} (${option.RmiCity ? option.RmiCity : 'N/A'})`}</Option>;
                          })}
                        </Select>
                      </div>
                    </>
                  )
                  : null
                }
              </div>

            </div>

            <Card title="Member Overview" className="mb-4 member-overview">
              <div className="row">
                <div className="col-lg-24 col-md-24">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <Radio.Group
                            className="mr-3 pb-2 pt-2 pl-3"
                            onChange={onTrendChange} value={trend}
                            style={{ border: '1px solid', borderColor: '#d9d9d9', padding: '4px' }}
                          >
                            <Radio value={'M'}>Past 3 Months</Radio>
                            <Radio value={'Y'}>Year to date</Radio>
                          </Radio.Group>
                        </td>
                        <td>
                          <Button
                            type="primary"
                            icon={<PrinterOutlined />}
                            onClick={printMembersReport}
                            disabled={!showData}
                          >
                            Print
                          </Button>
                          <Button
                            className="ml-3 print"
                            type="primary"
                            icon={<CloudDownloadOutlined />}
                            onClick={downloadMemberFile}
                            disabled={!showData}
                          >
                            Download
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col-md-8">
                  <div id="newMembersTable"
                    style={{
                      maxHeight: newMembersTableHeight,
                      overflowY: (newMembersTableHeight < 620) ? 'hidden' : 'scroll'
                    }}
                  >
                    <InfiniteScroll
                      dataLength={newMembersDataSource.length}
                      next={() => getForAlertsRowOne(PAGE_SIZE, COLUMN_NAME.NEW_MEMBERS, newMembersPageIndex.current)}
                      hasMore={moreNewMembers}
                      loader={<></>}
                      scrollableTarget="newMembersTable"
                    >
                      <Table
                        className={styles['min-row-height']}
                        columns={newMembersColumns}
                        dataSource={newMembersDataSource}
                        loading={props.isFetchingRow1}
                        pagination={false}
                      />
                    </InfiniteScroll>
                  </div>
                </div>

                <div className="col-md-8">
                  <div id="termedMembersTable"
                    style={{
                      maxHeight: termedMembersTableHeight,
                      overflowY: (termedMembersTableHeight < 620) ? 'hidden' : 'scroll'
                    }}
                  >
                    <InfiniteScroll
                      dataLength={termedMembersDataSource.length}
                      next={() => getForAlertsRowOne(PAGE_SIZE, COLUMN_NAME.TERMED_MEMBERS, termedMembersPageIndex.current)}
                      hasMore={moreTermedMembers}
                      loader={<></>}
                      scrollableTarget="termedMembersTable"
                    >
                      <Table
                        className={styles['min-row-height']}
                        columns={termedMembersColumns}
                        dataSource={termedMembersDataSource}
                        loading={props.isFetchingRow1}
                        pagination={false}
                      />
                    </InfiniteScroll>
                  </div>
                </div>

                <div className="col-md-8">
                  <div id="ihaMembersTable"
                    style={{
                      maxHeight: ihaMembersTableHeight,
                      overflowY: (ihaMembersTableHeight < 620) ? 'hidden' : 'scroll'
                    }}
                  >
                    <InfiniteScroll
                      dataLength={ihaMembersDataSource.length}
                      next={() => getForAlertsRowOne(PAGE_SIZE, COLUMN_NAME.IHA_MEMBERS, ihaMembersPageIndex.current)}
                      hasMore={moreIhaMembers}
                      loader={<></>}
                      scrollableTarget="ihaMembersTable"
                    >
                      <Table
                        className={styles['min-row-height']}
                        columns={ihaMembersColumns}
                        dataSource={ihaMembersDataSource}
                        loading={props.isFetchingRow1}
                        pagination={false}
                      />
                    </InfiniteScroll>
                  </div>
                </div>
              </div>
            </Card>

            { isUserEnabledForPBI(sessionStorage.getItem('user_id'), constants.PBI_ENABLE_USER) ? (
              <div className="pbi-card">
                <div className="pbi-card-body">
                  <h5 className="pbi-card-title">Compensation Dashboard</h5>
                  <div className="pbi-card-text">
                    <p>Mid-Year Performance, Annual Visit Rate by Month, HCC Recapture Rate by Month, Quality Gap Closure by Measure, Membership Volume by LOB</p>
                    <button onClick={handleOpenClick} className="pbi-btn-primary">Open</button>
                  </div>
                </div>
              </div>
            ) : null}

            <div className="row mt-2">
              <div className="col-3">
                <FloatLabel label="Measure Year" value={measureYear}>
                  <Select
                    className="mb-2"
                    showSearch
                    value={measureYear}
                    placeholder="ALL"
                    onChange={value => setMeasureYear(value)}
                  >
                    <Option key={1} value={moment().year()}>{moment().year()}</Option>
                    <Option key={2} value={moment().year() - 1}>{moment().year() - 1}</Option>
                  </Select>
                </FloatLabel>
              </div>
            </div>

            { Math.round(overallPerformance.OverallRating) > 0 && (
              <Card className="mb-4 metrics">
                <div className="row">
                  <>
                    <div className="col-lg-12 col-md-12">
                      <Card title="Senior Quality Measures Overview" className="senior-quality-card">
                        <div className="row mb-5">
                          <div className="col-lg-24 col-md-24">
                            <div style={{display: "inline"}}>Overall Star Rating: </div>
                              <div className="rating-score mr-1">{overallPerformance.OverallRating}</div>
                              <div className="stars">{overallPerformance.OverallRating > 0 ? Array(Math.round(overallPerformance.OverallRating)).fill(<i className="fa fa-star star"></i>) : 'N/A'}</div>
                              {showAWV && <div className="awv-rating">AWV Completion Rating: {awv.toFixed(2) || 0.00}%</div>}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-24">
                            <div style={{display: "inline"}}>
                              <ConfigProvider getPopupContainer={(triggerNode: any) => triggerNode.parentNode}>
                                <Slider style={{ zIndex: 1000 }} marks={sliderMarkers} tooltipVisible value={overallPerformance.OverallPercentile} disabled={true} />
                              </ConfigProvider>
                                {/* TODO: Add in Top <value> % to the tooltip and added custom color to slider */}
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          { bestMeasures?.length > 0 && (
                            <>
                              <div className="col-lg-12 text-center">
                                Best Measures
                                { bestMeasures.map((measure: any) => {
                                  return (
                                    <Card className="card-box mb-3">
                                      <div className="metric-name">{measure.MeasureName}</div>
                                      {measure.StarRating > 0 ? Array(measure.StarRating).fill(<i className="fa fa-star star"></i>) : 'N/A'}
                                    </Card>
                                  );
                                })}
                              </div>
                            </>
                          )}

                          { needsImprovementMeasures?.length > 0 && (
                            <div className="col-lg-12 text-center">
                              Needs Improvement
                              { needsImprovementMeasures.map((measure: any) => {
                                return (
                                  <Card className="card-box mb-3">
                                    <div className="metric-name">{measure.MeasureName}</div>
                                    {measure.StarRating > 0 ? Array(measure.StarRating).fill(<i className="fa fa-star star"></i>) : 'N/A'}
                                  </Card>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </Card>
                    </div>
                  </>

                  {(
                    <div className="col-lg-12 col-md-12">
                    <Card title="MA Risk Adjustment Metrics" className="senior-risk-card">
                      <div className="row">
                        {rafScore?.length > 0 && rafScore[0]?.RmiMedicareRAF > 0 && rafScore[0]?.MonthYear && (
                          <MetricCard
                            title={`CY${new Date(rafScore[0].MonthYear).getFullYear() - 2} - CY${new Date(rafScore[0].MonthYear).getFullYear() - 1} Medicare RAF (${new Date(rafScore[0]?.MonthYear).getMonth() + 1 === 11 ? "Nov Score" : "May Score"})`}
                            score={Math.round(rafScore[0].RmiMedicareRAF * 100) / 100}
                          />
                        )}

                        {rafScore?.length > 0 && rafScore[0]?.RmiMediMediRAF > 0 && rafScore[0]?.MonthYear && (
                          <MetricCard
                            title={`CY${new Date(rafScore[0].MonthYear).getFullYear() - 2} - CY${new Date(rafScore[0].MonthYear).getFullYear() - 1} Dual RAF (${new Date(rafScore[0]?.MonthYear).getMonth() + 1 === 11 ? "Nov Score" : "May Score"})`}
                            score={Math.round(rafScore[0].RmiMediMediRAF * 100) / 100}
                          />
                        )}

                        {metricScore?.RmiMedicareRAF > 0 && (
                          <MetricCard
                            title={`CY${measureYear} Build Up / Potential RAF`}
                            score={Math.round(metricScore.RmiMedicareRAF * 100) / 100}
                          />
                        )}
                      </div>

                      <div className="row">
                        {metricScore?.chronic_condition_recaptured > 0 && (
                          <MetricCard
                            title="Chronic Conditions Recaptured"
                            score={`${metricScore.chronic_condition_recaptured}%`}
                          />
                        )}

                        {metricScore?.suspected_condition_recaptured > 0 && (
                          <MetricCard
                            title="Suspected Conditions Captured"
                            score={`${metricScore.suspected_condition_recaptured}%`}
                          />
                        )}

                        {metricScore?.medicare_members > 0 && (
                          <MetricCard
                            title="Medicare Members"
                            score={metricScore.medicare_members}
                          />
                        )}
                      </div>
                    </Card>
                  </div>
                  )}
                </div>
              </Card>
            )}

            {apiCallCompleted && !showMeasureTable && measureYear == moment().year() && (
              <div className="alert">
                {`${moment().year()} Quality Measures, Risk Metrics, and Measures for Improvement will be available shortly. Please change measure year to ${moment().year() - 1} to review previous year information`}
              </div>
            )}

            { apiCallCompleted && showMeasureTable && (
              <Card title="Measures for Improvement" className="measures-form-improvement mb-4">
                <div className="row print">
                  <div className="col-md-12" style={{float: 'left'}}>
                    <FloatLabel label="Line Of Business" value={lob}>
                      <Select
                        showSearch
                        value={lob}
                        placeholder="ALL"
                        onChange={value => setLob(value)}
                      >
                        <Option key={1} value={LineOfBusiness.COMMERCIAL}>{LineOfBusiness.COMMERCIAL}</Option>
                        <Option key={2} value={LineOfBusiness.MEDICARE}>{LineOfBusiness.MEDICARE}</Option>
                        <Option key={3} value={LineOfBusiness.MEDICAL}>{LineOfBusiness.MEDICAL}</Option>
                        <Option key={4} value={LineOfBusiness.ALL}>{LineOfBusiness.ALL}</Option>
                      </Select>
                    </FloatLabel>
                    </div>

                  <div className="col-md-4 mt-2 print btn-Spacing">
                    <Button
                      type="primary"
                      icon={<PrinterOutlined />}
                      onClick={printGapReportInXlsx}
                      disabled={!showData}
                    >
                      Print Gap Report (xlsx)
                    </Button>
                  </div>
                  <div className="col-md-4 mt-2 print">
                    <Button
                      type="primary"
                      icon={<PrinterOutlined />}
                      onClick={printGapReportInPdf}
                      disabled={!showData}
                    >
                      Print Gap Report (pdf)
                    </Button>
                  </div>

                  <div className="col-md-8">
                    <div className={lob === LineOfBusiness.MEDICARE ? "show" : "hide"} style={{float: "right"}}>
                      <p>Only Medicare measures have star ratings.</p>
                    </div>
                  </div>
                </div>
                <Table
                  columns={measuresImprovementColumns}
                  dataSource={measuresImprovementDataSource}
                  pagination={false}
                  loading={props.isFetchingHEDIS}
                  expandRowByClick={true}
                  expandable={{
                    expandedRowRender: (record) =>
                    (
                      <>
                        <Card className="card-box">
                          <div id="membersTable"
                            style={{
                              maxHeight: membersTableHeight,
                              overflowY: (membersTableHeight < 1170) ? 'hidden' : 'scroll'
                            }}
                          >
                            <InfiniteScroll
                              dataLength={measureImprovementExpandDataSource.length}
                              next={() => getMembers(record, membersPageIndex.current)}
                              hasMore={moreMembers}
                              loader={<></>}
                              scrollableTarget="membersTable"
                            >
                              <Table
                                columns={measureImprovementExpandColumns}
                                dataSource={measureImprovementExpandDataSource}
                                loading={props.isFetchingMembers}
                                pagination={false}
                                rowKey={'key'}
                              />
                            </InfiniteScroll>
                          </div>
                        </Card>
                      </>
                    ),
                    rowExpandable: (record) => {
                      if (record.RmiMeasureCode !== 'MHAWV') {
                        return true;
                      } else {
                        return false;
                      }
                    }
                  }}
                  onExpand={(_, record) => handleRowExpand(record)}
                  expandedRowKeys={[collapseState.expandedRow]}
                />
              </Card>
            )}

          </>
        )}
      </div>

      <GeneralProviderTraining
        setShowTraining={setShowTraining}
        setAgreementCheckbox={setAgreementCheckbox}
        CheckAttestationVisibility={props.CheckAttestationVisibility}
        AddAttestationAcknowledgement={props.AddAttestationAcknowledgement}
        DownloadAttestation={props.DownloadAttestation}
        GetAttestationPopupContent={props.GetAttestationPopupContent}
        showTraining={showTraining}
        agreementCheckbox={agreementCheckbox}
        isCreatingGenProv={props.isCreatingGenProv}
      />

      <PNOProviderTraining
        setShowPNOTraining={setShowPNOTraining}
        setPNOAgreementCheckbox={setPNOAgreementCheckbox}
        CheckAttestationVisibility={props.CheckAttestationVisibility}
        AddAttestationAcknowledgement={props.AddAttestationAcknowledgement}
        DownloadAttestation={props.DownloadAttestation}
        getDownloadResources={props.getDownloadResources}
        GetAttestationPopupContent={props.GetAttestationPopupContent}
        showPNOTraining={showPNOTraining}
        PNOAgreementCheckbox={PNOAgreementCheckbox}
        isAddingAttestation={props.isAddingAttestation}
      />

      <MemoReminderModal />
    </>
  );
}

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingDistinct: store.rootReducer.appProviderKeyListWDates.isFetchingDistinct, //Search Eligibility table
  isSearchingMembers: store.rootReducer.eligibility.isSearchingMembers, //Search Eligibility table
  isFetchingMedicare: store.rootReducer.measure.isFetchingMedicare, //metric score
  isFetchingHistoricalRafScore: store.rootReducer.eligibilityRAFScore.isFetchingHistoricalRafScore, //RAF score
  isFetchingHEDIS: store.rootReducer.eligibilityGAP.isFetchingHEDIS, // Measures for Improvement table
  isFetchingOverallPerformance: store.rootReducer.eligibilityMeasures.isFetchingOverallPerformance, //Overall Performance slider thing and Overall Rating
  isFetchingEnabledList: store.rootReducer.authProvider.isFetchingEnabledList, // provider dropdown list
  isFetchingRow1: store.rootReducer.eligibilityMembers.isFetchingRow1, // view members result table
  isCreatingGenProv: store.rootReducer.app.isCreatingGenProv, //submitting general provider acknowledgement
  isCreatingWebPilotPosing: store.rootReducer.app.isCreatingWebPilotPosing,//submitting Fax Opt
  isFetchingMembers: store.rootReducer.eligibilityMeasures.isFetchingMembers, //fetching more members expanded measures for improvement,
  isAddingAttestation: store.rootReducer.app.isAddingAttestation,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getFaxOptOutExists,
    bulkInsertFaxOptOutProviders,
    getAuthEnabledProviderList,
    getMedicareMetricsOverview,
    getHistoricalRafScore,
    getProviderHedis,
    getMembers,
    getProviderReport,
    getDownloadDocument,
    getProviderOverallPerformance,
    getDistinct,
    getDistinctVendors,
    printMembersReport,
    downloadMemberFile,
    getForAlertsRow1,
    getAlertCount,
    getMeasureReportPrintFile,
    getProviderKeyListWDates,
    showUrgentAnnouncement,

    //eligibility info page related
    search,
    getAllDesc,
    getContractedIPA,
    CheckAttestationVisibility,
    AddAttestationAcknowledgement,
    DownloadAttestation,
    GetAttestationPopupContent,
    getDownloadResources
  },
  dispatch,
);


export default connect(mapStateToProps, mapDispatchToProps)(QualityOverViewPage);